import { render, staticRenderFns } from "./bill-checked-reject.vue?vue&type=template&id=705547fc"
import script from "./bill-checked-reject.vue?vue&type=script&lang=js"
export * from "./bill-checked-reject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports